import { useEffect, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { pageIndicator } from "../apollo";
import {
  ComponentTabLink,
  ITabLink,
  ITabTitle,
  PageType,
} from "../components/component-tab";
import { AsideAdminComponent } from "../layout/aside-admin";
import plus from "../assets/icon/plus.svg";
import { FormError2 } from "../components/form-error";
import {
  GoodStatusOption,
  GoodStatusOptionType,
  relatedProps,
  TagList,
} from "../constants/enum";
import { Button } from "../components/button";
import { useListCorporationSelect } from "../hooks/useListCorprationSelect";
import { Autocomplete, TextField } from "@mui/material";
import { useListGoodAll } from "../hooks/useListGoodAll";
import del from "../assets/icon/exit.png";
import { ICrGoodFormProps, useCrGood } from "../hooks/useCrGood";
import {
  Tags,
  CrGoodInput,
  CrGoodMutation,
  ListGoodAllQuery,
  ListCorporationSelectQuery,
  ListSubCategoryQuery,
} from "../generated/graphql";
import { useLocation } from "react-router-dom";
import CreatableSelect from "react-select/creatable";
import { useListSubCategory } from "../hooks/useListSubCategory";

export const AdminCrProduct = () => {
  const location = useLocation();
  const corporationId = (location.state as { corporationId: number })
    ?.corporationId;

  const completed = (data: ListSubCategoryQuery) => {
    const {
      listSubCategory: { ok, err, subCategories },
    } = data;
    if (ok) {
      setSubCategories(subCategories || []);
    } else {
      setSubCategories([]);
    }
  };
  const [
    listSubCategory,
    { data, loading: subCategoryLoading },
  ] = useListSubCategory(completed);
  const [subCategories, setSubCategories] = useState<any[]>([]);
  const [selectedValue, setSelectedValue] = useState<any | null>(null);
  console.log(selectedValue);
  const [out, setOut] = useState<boolean>(true);

  const [cor, setCor] = useState<any[]>([]);
  useEffect(() => {
    if (corporationId && cor.length > 0) {
      // cor 배열에서 ID와 일치하는 '객체'를 찾음
      const initialCorporation = cor.find((item) => item.id === corporationId);
      if (initialCorporation) {
        setSelectedValue(initialCorporation);
      }
    }
  }, [corporationId, cor]);
  // 태그
  const [tags, setTags] = useState<Tags[]>([]);
  const addTagHandler = (values: Tags) => {
    setTags([...tags, values]);
  };
  const removeTagHandler = (values: Tags) => {
    setTags(tags.filter((a) => a !== values));
  };
  useEffect(() => {
    pageIndicator("product");
  }, []);

  const onListCorporation = (data: ListCorporationSelectQuery) => {
    const {
      listCorporationSelect: { ok, err, corporations },
    } = data;
    if (ok) {
      setCor(corporations || []);
    }
  };
  const [
    listCorporationSelect,
    { data: corporation },
  ] = useListCorporationSelect(onListCorporation);
  const {
    getValues,
    register,
    handleSubmit,
    watch,
    control,
    formState: { errors, isValid },
  } = useForm<ICrGoodFormProps>({ mode: "all" });

  const onComplete = async (data: CrGoodMutation) => {
    const {
      crGood: { ok, err },
    } = data;
    if (ok) {
      setOut(false);
      // alert("저장되었습니다");
      window.location.href = `/product/update/${data.crGood.createdId}`;
    } else {
      alert(err);
    }
  };

  const [crGood, { loading }] = useCrGood(onComplete);
  const onSubmit = () => {
    if (!loading) {
      const {
        price,
        discountRate,
        weight,
        subCategory,
        title,
        summary,
        status,
      } = getValues();
      console.log(selectedValue?.id);
      const crGoodInput: CrGoodInput = {
        discountRate: discountRate ? +discountRate : 0,
        tags: tags,
        price: price ? +price : 1000,
        weight: weight ? +weight : null,
        title,
        summary,
        status,
        corporationId: +selectedValue?.id,
        subCategoryName: subCategory ? subCategory.value : null,
      };
      crGood({ variables: { input: crGoodInput } });
    }
  };

  /// 거래처
  const tabList: ITabLink[] = [];
  const stitle: ITabTitle = { text: "상품 등록" };

  const onlistCall = (data: ListGoodAllQuery) => {
    const {
      listGoodAll: { ok, err, goods },
    } = data;
  };
  const [listGoodAll] = useListGoodAll(onlistCall);

  useEffect(() => {
    listGoodAll();
    listCorporationSelect();
  }, []);

  useEffect(() => {
    // 1. selectedValue에 유효한 값이 있을 때 (객체가 선택되었을 때)
    if (selectedValue?.id) {
      // selectedValue의 id를 사용하여 listSubCategory 함수를 호출합니다.
      listSubCategory({
        variables: {
          input: {
            corporationId: selectedValue.id,
          },
        },
      });
    }
    // 2. selectedValue가 null일 때 (선택이 해제되었을 때)
    else {
      setSubCategories([]);
      // 필요하다면, 카테고리 목록을 비우는 로직을 추가할 수 있습니다.
      // 예: setSubCategoryOptions([]);
    }
  }, [selectedValue, listSubCategory]); // selectedValue가 바뀔 때마다 이 effect가 실행됩니다.

  return (
    <div className="bg-main bg-opacity-50 w-full h-full min-h-screen">
      <div className="w-full mx-auto h-full min-h-screen  bg-gray-100">
        <main id="main">
          <div className="grid grid-cols-[200px_1fr] max-w-full">
            <AsideAdminComponent />
            <div className="mypages bg-gray-100 w-full min-w-[1200px] overflow-hidden">
              <div className="orderWrap">
                <div className="h-fix-content relative">
                  <div className={`w-full h-full px-10 py-8`}>
                    <ComponentTabLink
                      tabs={tabList}
                      stitle={stitle}
                      type={PageType.Create}
                    />
                    <div className="shadow-lg h-fix-content overflow-auto bg-white">
                      <form id="create" onSubmit={handleSubmit(onSubmit)}>
                        <div className="pl-9 pr-11 py-8 space-y-4">
                          <div className="space-y-2">
                            <p className="font-bold text-[#4F4F4F] text-base">
                              상품명
                            </p>
                            <input
                              {...register("title", {
                                required: `상품명을 입력해주세요`,
                              })}
                              type="text"
                              className="border w-full h-10 border-[#F0F0F4] text-base rounded-lg py-1 px-4"
                            />
                            {errors.title?.message && (
                              <FormError2 errorMessage={errors.title.message} />
                            )}
                          </div>
                          <div className="grid grid-cols-2 gap-x-6">
                            <div className="space-y-2">
                              <p className="font-bold text-[#4F4F4F] text-base">
                                상품설명
                              </p>
                              <input
                                {...register("summary", {
                                  required: "부제 입력해주세요",
                                })}
                                type="text"
                                className="border w-full h-10 border-[#F0F0F4] text-base rounded-lg py-1 px-4"
                              ></input>
                              {errors.summary?.message && (
                                <FormError2
                                  errorMessage={errors.summary.message}
                                />
                              )}
                            </div>
                          </div>
                          {/* <div className="space-y-2">
                            <p className="font-bold text-[#4F4F4F] text-base">
                              상품설명
                            </p>
                            <input
                              {...register("summary", {
                                required: `상품설명을 입력해주세요`,
                              })}
                              type="text"
                              className="border w-full h-10 border-[#F0F0F4] text-base rounded-lg py-1 px-4"
                            ></input>
                            {errors.desc?.message && (
                              <FormError2 errorMessage={errors.desc.message} />
                            )}
                          </div>
                          <div className="space-y-2">
                            <p className="font-bold text-[#4F4F4F] text-base">
                              옵션명
                            </p>
                            <input
                              {...register("name", {})}
                              type="text"
                              className="border w-full h-10 border-[#F0F0F4] text-base rounded-lg py-1 px-4"
                            ></input>
                          </div> */}
                          <div className="grid grid-cols-2 gap-x-6">
                            <div className="space-y-2">
                              <div className="font-bold text-[#4F4F4F] text-base">
                                거래처 이름
                              </div>
                              <div className="w-full">
                                <Autocomplete
                                  // value prop에는 객체 또는 null이 전달됨
                                  value={selectedValue}
                                  onChange={(event, newValue) => {
                                    // onChange의 newValue도 객체 또는 null임
                                    setSelectedValue(newValue);
                                  }}
                                  // options는 객체 배열
                                  options={cor}
                                  // 추가: 옵션 객체에서 화면에 표시할 문자열을 반환하는 방법을 알려줌
                                  getOptionLabel={(option) => option.name || ""}
                                  // 추가: value 객체와 options 내의 객체를 비교하는 방법을 알려줌
                                  isOptionEqualToValue={(option, value) =>
                                    option.id === value.id
                                  }
                                  disablePortal
                                  autoComplete
                                  sx={{ padding: 0 }}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      sx={{ width: "100%" }}
                                      placeholder="등록할 거래처를 적어주세요"
                                    />
                                  )}
                                />
                              </div>
                            </div>
                            <div className="space-y-2">
                              <p className="font-bold text-[#4F4F4F] text-base">
                                상품 카테고리
                              </p>
                              <Controller
                                name="subCategory" // react-hook-form 필드 이름 확인
                                control={control}
                                render={({ field }) => (
                                  <CreatableSelect
                                    {...field}
                                    isClearable
                                    // 3. (변경) 로딩 상태와 플레이스홀더를 개선합니다.
                                    isLoading={subCategoryLoading}
                                    placeholder={
                                      subCategoryLoading
                                        ? "카테고리 불러오는 중..."
                                        : "카테고리를 선택하거나 직접 입력하세요..."
                                    }
                                    options={subCategories.map((category) => ({
                                      value: category.name,
                                      label: category.name,
                                    }))}
                                    formatCreateLabel={(inputValue) =>
                                      `"${inputValue}" 새로 만들기`
                                    }
                                  />
                                )}
                              />
                            </div>
                          </div>
                          <div className="grid grid-cols-2 gap-x-6">
                            <div className="space-y-2">
                              <p className="font-bold text-[#4F4F4F] text-base">
                                판매 상태
                              </p>
                              <div className="grid grid-cols-4">
                                {Object(GoodStatusOption).map(
                                  (
                                    goodStatus: GoodStatusOptionType,
                                    index: number
                                  ) => (
                                    <div
                                      className=""
                                      key={`goodStatus-option-${index}`}
                                    >
                                      <input
                                        {...register(`status`, {})}
                                        className="border border-[#F0F0F4] rounded-lg py-1 px-2 w-full text-base"
                                        type="radio"
                                        name="status"
                                        defaultChecked={index === 0}
                                        id={goodStatus.label}
                                        value={goodStatus.value}
                                      ></input>
                                      <label
                                        htmlFor={goodStatus.label}
                                        className="px-2"
                                      >
                                        {goodStatus.label}
                                      </label>
                                    </div>
                                  )
                                )}
                              </div>
                              {/* <select
                                {...register(`status`, {})}
                                className="border border-[#F0F0F4] rounded-lg py-1 px-2 w-full text-base"
                              >
                                {Object(GoodStatusOption).map(
                                  (
                                    goodStatus: GoodStatusOptionType,
                                    index: number
                                  ) => (
                                    <option
                                      key={`goodStatus-option-${index}`}
                                      value={goodStatus.value}
                                      selected={index === 1}
                                      disabled={index === 0}
                                    >
                                      {goodStatus.label}
                                    </option>
                                  )
                                )}
                              </select> */}
                            </div>
                            {/* <div className="space-y-2">
                              <p className="font-bold text-[#4F4F4F] text-base">
                                유통기한
                              </p>
                              <input
                                {...register("expirydate", {
                                  required: `유통기한을 입력해주세요`,
                                })}
                                type="date"
                                className="border w-full h-10 border-[#F0F0F4] text-base rounded-lg py-1 px-4"
                              />
                              {errors.expirydate?.message && (
                                <FormError2
                                  errorMessage={errors.expirydate.message}
                                />
                              )}
                            </div> */}
                          </div>

                          <div className="grid grid-cols-3 gap-x-6">
                            <div className="space-y-2">
                              <p className="font-bold text-[#4F4F4F] text-base">
                                무게
                              </p>
                              <div className="flex flex-wrap">
                                <input
                                  {...register("weight", {})}
                                  type="number"
                                  min={0}
                                  className="border  w-4/5 h-10 border-[#F0F0F4] text-base rounded-lg py-1 px-4"
                                ></input>
                                <p className="pl-2 my-2">g</p>
                              </div>
                              {errors.weight?.message && (
                                <FormError2
                                  errorMessage={errors.weight.message}
                                />
                              )}
                            </div>
                            <div className="space-y-2">
                              <p className="font-bold text-[#4F4F4F] text-base">
                                판매가
                              </p>
                              <div className="flex flex-wrap">
                                <input
                                  {...register("price", {
                                    required: `가격을 입력해주세요`,
                                  })}
                                  type="number"
                                  min={0}
                                  className="price border w-4/5 h-10 border-[#F0F0F4] text-base rounded-lg py-1 px-4"
                                ></input>
                                <p className="pl-2 my-2">원</p>
                              </div>
                              {errors.price?.message && (
                                <FormError2
                                  errorMessage={errors.price.message}
                                />
                              )}
                            </div>
                            <div className="space-y-2">
                              <p className="font-bold text-[#4F4F4F] text-base">
                                할인율
                              </p>
                              <div className="flex flex-wrap">
                                <input
                                  {...register("discountRate", {
                                    required: `할인율을 입력해주세요`,
                                  })}
                                  type="number"
                                  min={0}
                                  max={100}
                                  defaultValue={0}
                                  className="border w-4/5 h-10 border-[#F0F0F4] text-base rounded-lg py-1 px-4"
                                ></input>
                                <p className="pl-2 my-2">%</p>
                              </div>
                              {errors.discountRate?.message && (
                                <FormError2
                                  errorMessage={errors.discountRate.message}
                                />
                              )}
                            </div>
                          </div>
                          {/* <div className="space-y-2">
                            <p className="font-bold text-[#4F4F4F] text-base">
                              연관상품
                            </p>
                            <Autocomplete
                              disablePortal
                              options={relations}
                              autoComplete
                              sx={{ padding: 0 }}
                              onChange={(detail, value) => {
                                makeRelation(value);
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  sx={{ width: "100%" }}
                                  placeholder="등록할 연관상품을 적어주세요"
                                />
                              )}
                            />
                            <p className="pt-4 space-x-4 space-y-2">
                              {relatedGoods &&
                                relatedGoods.length > 0 &&
                                relatedGoods.map((el) => (
                                  <span
                                    key={`relateion-width-${el.value}`}
                                    className="text-sm text-darkFont bg-gray-200 rounded-full py-1 px-2  inlie-flex flex-wrap content-center"
                                  >
                                    {el.label}
                                    <button
                                      className="px-2"
                                      onClick={() => {
                                        deleteRelation(el);
                                      }}
                                    >
                                      <img
                                        src={del}
                                        alt="remove this relations"
                                        className="inline invert w-4"
                                      />
                                    </button>
                                  </span>
                                ))}
                            </p>
                          </div> */}
                          <div className="space-y-2">
                            <p className="font-bold text-[#4F4F4F] text-base">
                              태그
                            </p>

                            <div className="pt-4 flex flex-wrap content-center gap-x-4">
                              {TagList.map((tag) => (
                                <label
                                  key={`tags-${tag.name}`}
                                  className="text-lg"
                                >
                                  <input
                                    checked={tags.includes(tag.value)}
                                    onChange={() => {
                                      if (tags.includes(tag.value)) {
                                        removeTagHandler(tag.value);
                                      } else {
                                        addTagHandler(tag.value);
                                      }
                                    }}
                                    type="checkbox"
                                    value={tag.value}
                                  />
                                  <span className="pl-2">{tag.name}</span>
                                </label>
                              ))}
                            </div>
                          </div>
                          <div className="flex flex-wrap justify-center pt-6">
                            <Button
                              className={`test w-[240px] h-[40px] bg-[#3D3E49] text-white rounded-lg`}
                              canClick={true}
                              actionText={`등록`}
                              loading={loading}
                              color={"text-white"}
                            />
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};
